export interface KeyboardData {
  type: 'white' | 'black',
  note: string,
  basic_note: string,
  id: number,
  french_note: string,
  numBlackKeysBefore: number,
  zone?: string
}

const KEYBOARD_DATA: KeyboardData[] = [
  {
    type: 'white',
    note: 'A0',
    basic_note: 'a',
    id: 1,
    french_note: 'La',
    numBlackKeysBefore: 0,
  },
  {
    type: 'black',
    note: 'A#0',
    basic_note: 'a_sharp',
    id: 2,
    french_note: 'La#',
    numBlackKeysBefore: 0,
  },
  {
    type: 'white',
    note: 'B0',
    basic_note: 'b',
    id: 3,
    french_note: 'Si',
    numBlackKeysBefore: 1,
  },
  {
    type: 'white',
    note: 'C1',
    basic_note: 'c',
    id: 4,
    zone: '-3',
    french_note: 'Do',
    numBlackKeysBefore: 1,
  },
  {
    type: 'black',
    note: 'C#1',
    basic_note: 'c_sharp',
    id: 5,
    french_note: 'Do#',
    numBlackKeysBefore: 1,
  },
  {
    type: 'white',
    note: 'D1',
    basic_note: 'd',
    id: 6,
    french_note: 'Ré',
    numBlackKeysBefore: 2,
  },
  {
    type: 'black',
    note: 'D#1',
    basic_note: 'd_sharp',
    id: 7,
    french_note: 'Ré#',
    numBlackKeysBefore: 2,
  },
  {
    type: 'white',
    note: 'E1',
    basic_note: 'e',
    id: 8,
    french_note: 'Mi',
    numBlackKeysBefore: 3,
  },
  {
    type: 'white',
    note: 'F1',
    basic_note: 'f',
    id: 9,
    french_note: 'Fa',
    numBlackKeysBefore: 3,
  },
  {
    type: 'black',
    note: 'F#1',
    basic_note: 'f_sharp',
    id: 10,
    french_note: 'Fa#',
    numBlackKeysBefore: 3,
  },
  {
    type: 'white',
    note: 'G1',
    basic_note: 'g',
    id: 11,
    french_note: 'Sol',
    numBlackKeysBefore: 4,
  },
  {
    type: 'black',
    note: 'G#1',
    basic_note: 'g_sharp',
    id: 12,
    french_note: 'Sol#',
    numBlackKeysBefore: 4,
  },
  {
    type: 'white',
    note: 'A1',
    basic_note: 'a',
    id: 13,
    french_note: 'La',
    numBlackKeysBefore: 5,
  },
  {
    type: 'black',
    note: 'A#1',
    basic_note: 'a_sharp',
    id: 14,
    french_note: 'La#',
    numBlackKeysBefore: 5,
  },
  {
    type: 'white',
    note: 'B1',
    basic_note: 'b',
    id: 15,
    french_note: 'Si',
    numBlackKeysBefore: 6,
  },
  {
    type: 'white',
    note: 'C2',
    basic_note: 'c',
    id: 16,
    zone: '-2',
    french_note: 'Do',
    numBlackKeysBefore: 6,
  },
  {
    type: 'black',
    note: 'C#2',
    basic_note: 'c_sharp',
    id: 17,
    french_note: 'Do#',
    numBlackKeysBefore: 6,
  },
  {
    type: 'white',
    note: 'D2',
    basic_note: 'd',
    id: 18,
    french_note: 'Ré',
    numBlackKeysBefore: 7,
  },
  {
    type: 'black',
    note: 'D#2',
    basic_note: 'd_sharp',
    id: 19,
    french_note: 'Ré#',
    numBlackKeysBefore: 7,
  },
  {
    type: 'white',
    note: 'E2',
    basic_note: 'e',
    id: 20,
    french_note: 'Mi',
    numBlackKeysBefore: 8,
  },
  {
    type: 'white',
    note: 'F2',
    basic_note: 'f',
    id: 21,
    french_note: 'Fa',
    numBlackKeysBefore: 8,
  },
  {
    type: 'black',
    note: 'F#2',
    basic_note: 'f_sharp',
    id: 22,
    french_note: 'Fa#',
    numBlackKeysBefore: 8,
  },
  {
    type: 'white',
    note: 'G2',
    basic_note: 'g',
    id: 23,
    french_note: 'Sol',
    numBlackKeysBefore: 9,
  },
  {
    type: 'black',
    note: 'G#2',
    basic_note: 'g_shap',
    id: 24,
    french_note: 'Sol#',
    numBlackKeysBefore: 9,
  },
  {
    type: 'white',
    note: 'A2',
    basic_note: 'a',
    id: 25,
    french_note: 'La',
    numBlackKeysBefore: 10,
  },
  {
    type: 'black',
    note: 'A#2',
    basic_note: 'a',
    id: 26,
    french_note: 'La#',
    numBlackKeysBefore: 10,
  },
  {
    type: 'white',
    note: 'B2',
    basic_note: 'b',
    id: 27,
    french_note: 'Si',
    numBlackKeysBefore: 11,
  },
  {
    type: 'white',
    note: 'C3',
    basic_note: 'c',
    id: 28,
    zone: '-1',
    french_note: 'Do',
    numBlackKeysBefore: 11,
  },
  {
    type: 'black',
    note: 'C#3',
    basic_note: 'c_sharp',
    id: 29,
    french_note: 'Do#',
    numBlackKeysBefore: 11,
  },
  {
    type: 'white',
    note: 'D3',
    basic_note: 'd',
    id: 30,
    french_note: 'Ré',
    numBlackKeysBefore: 12,
  },
  {
    type: 'black',
    note: 'D#3',
    basic_note: 'd_sharp',
    id: 31,
    french_note: 'Ré#',
    numBlackKeysBefore: 12,
  },
  {
    type: 'white',
    note: 'E3',
    basic_note: 'e',
    id: 32,
    french_note: 'Mi',
    numBlackKeysBefore: 13,
  },
  {
    type: 'white',
    note: 'F3',
    basic_note: 'f',
    id: 33,
    french_note: 'Fa',
    numBlackKeysBefore: 13,
  },
  {
    type: 'black',
    note: 'F#3',
    basic_note: 'f_sharp',
    id: 34,
    french_note: 'Fa#',
    numBlackKeysBefore: 13,
  },
  {
    type: 'white',
    note: 'G3',
    basic_note: 'g',
    id: 35,
    french_note: 'Sol',
    numBlackKeysBefore: 14,
  },
  {
    type: 'black',
    note: 'G#3',
    basic_note: 'g_sharp',
    id: 36,
    french_note: 'Sol#',
    numBlackKeysBefore: 14,
  },
  {
    type: 'white',
    note: 'A3',
    basic_note: 'a',
    id: 37,
    french_note: 'La',
    numBlackKeysBefore: 15,
  },
  {
    type: 'black',
    note: 'A#3',
    basic_note: 'a_sharp',
    id: 38,
    french_note: 'La#',
    numBlackKeysBefore: 15,
  },
  {
    type: 'white',
    note: 'B3',
    basic_note: 'b',
    id: 39,
    french_note: 'Si',
    numBlackKeysBefore: 16,
  },
  {
    type: 'white',
    note: 'C4',
    basic_note: 'c',
    id: 40,
    zone: '0',
    french_note: 'Do',
    numBlackKeysBefore: 16,
  },
  {
    type: 'black',
    note: 'C#4',
    basic_note: 'c_sharp',
    id: 41,
    french_note: 'Do#',
    numBlackKeysBefore: 16,
  },
  {
    type: 'white',
    note: 'D4',
    basic_note: 'd',
    id: 42,
    french_note: 'Ré',
    numBlackKeysBefore: 17,
  },
  {
    type: 'black',
    note: 'D#4',
    basic_note: 'd_sharp',
    id: 43,
    french_note: 'Ré#',
    numBlackKeysBefore: 17,
  },
  {
    type: 'white',
    note: 'E4',
    basic_note: 'e',
    id: 44,
    french_note: 'Mi',
    numBlackKeysBefore: 18,
  },
  {
    type: 'white',
    note: 'F4',
    basic_note: 'f',
    id: 45,
    french_note: 'Fa',
    numBlackKeysBefore: 18,
  },
  {
    type: 'black',
    note: 'F#4',
    basic_note: 'f_sharp',
    id: 46,
    french_note: 'Fa#',
    numBlackKeysBefore: 18,
  },
  {
    type: 'white',
    note: 'G4',
    basic_note: 'g',
    id: 47,
    french_note: 'Sol',
    numBlackKeysBefore: 19,
  },
  {
    type: 'black',
    note: 'G#4',
    basic_note: 'g_sharp',
    id: 48,
    french_note: 'Sol#',
    numBlackKeysBefore: 19,
  },
  {
    type: 'white',
    note: 'A4',
    basic_note: 'a',
    id: 49,
    french_note: 'La',
    numBlackKeysBefore: 20,
  },
  {
    type: 'black',
    note: 'A#4',
    basic_note: 'a_sharp',
    id: 50,
    french_note: 'La#',
    numBlackKeysBefore: 20,
  },
  {
    type: 'white',
    note: 'B4',
    basic_note: 'b',
    id: 51,
    french_note: 'Si',
    numBlackKeysBefore: 21,
  },
  {
    type: 'white',
    note: 'C5',
    basic_note: 'c',
    id: 52,
    zone: '+1',
    french_note: 'Do',
    numBlackKeysBefore: 21,
  },
  {
    type: 'black',
    note: 'C#5',
    basic_note: 'c_sharp',
    id: 53,
    french_note: 'Do#',
    numBlackKeysBefore: 21,
  },
  {
    type: 'white',
    note: 'D5',
    basic_note: 'd',
    id: 54,
    french_note: 'Ré',
    numBlackKeysBefore: 22,
  },
  {
    type: 'black',
    note: 'D#5',
    basic_note: 'd_sharp',
    id: 55,
    french_note: 'Ré#',
    numBlackKeysBefore: 22,
  },
  {
    type: 'white',
    note: 'E5',
    basic_note: 'e',
    id: 56,
    french_note: 'Mi',
    numBlackKeysBefore: 23,
  },
  {
    type: 'white',
    note: 'F5',
    basic_note: 'f',
    id: 57,
    french_note: 'Fa',
    numBlackKeysBefore: 23,
  },
  {
    type: 'black',
    note: 'F#5',
    basic_note: 'f_sharp',
    id: 58,
    french_note: 'Fa#',
    numBlackKeysBefore: 23,
  },
  {
    type: 'white',
    note: 'G5',
    basic_note: 'g',
    id: 59,
    french_note: 'Sol',
    numBlackKeysBefore: 24,
  },
  {
    type: 'black',
    note: 'G#5',
    basic_note: 'g_sharp',
    id: 60,
    french_note: 'Sol#',
    numBlackKeysBefore: 24,
  },
  {
    type: 'white',
    note: 'A5',
    basic_note: 'a',
    id: 61,
    french_note: 'La',
    numBlackKeysBefore: 25,
  },
  {
    type: 'black',
    note: 'A#5',
    basic_note: 'a_sharp',
    id: 62,
    french_note: 'La#',
    numBlackKeysBefore: 25,
  },
  {
    type: 'white',
    note: 'B5',
    basic_note: 'b',
    id: 63,
    french_note: 'Si',
    numBlackKeysBefore: 26,
  },
  {
    type: 'white',
    note: 'C6',
    basic_note: 'c',
    id: 64,
    zone: '+2',
    french_note: 'Do',
    numBlackKeysBefore: 26,
  },
  {
    type: 'black',
    note: 'C#6',
    basic_note: 'c_sharp',
    id: 65,
    french_note: 'Do#',
    numBlackKeysBefore: 26,
  },
  {
    type: 'white',
    note: 'D6',
    basic_note: 'd',
    id: 66,
    french_note: 'Ré',
    numBlackKeysBefore: 27,
  },
  {
    type: 'black',
    note: 'D#6',
    basic_note: 'd',
    id: 67,
    french_note: 'Ré#',
    numBlackKeysBefore: 27,
  },
  {
    type: 'white',
    note: 'E6',
    basic_note: 'e',
    id: 68,
    french_note: 'Mi',
    numBlackKeysBefore: 28,
  },
  {
    type: 'white',
    note: 'F6',
    basic_note: 'f',
    id: 69,
    french_note: 'Fa',
    numBlackKeysBefore: 28,
  },
  {
    type: 'black',
    note: 'F#6',
    basic_note: 'f_sharp',
    id: 70,
    french_note: 'Fa#',
    numBlackKeysBefore: 28,
  },
  {
    type: 'white',
    note: 'G6',
    basic_note: 'g',
    id: 71,
    french_note: 'Sol',
    numBlackKeysBefore: 29,
  },
  {
    type: 'black',
    note: 'G#6',
    basic_note: 'g_sharp',
    id: 72,
    french_note: 'Sol#',
    numBlackKeysBefore: 29,
  },
  {
    type: 'white',
    note: 'A6',
    basic_note: 'a',
    id: 73,
    french_note: 'La',
    numBlackKeysBefore: 30,
  },
  {
    type: 'black',
    note: 'A#6',
    basic_note: 'a_sharp',
    id: 74,
    french_note: 'La#',
    numBlackKeysBefore: 30,
  },
  {
    type: 'white',
    note: 'B6',
    basic_note: 'b',
    id: 75,
    french_note: 'Si',
    numBlackKeysBefore: 31,
  },
  {
    type: 'white',
    note: 'C7',
    basic_note: 'c',
    id: 76,
    zone: '+2',
    french_note: 'Do',
    numBlackKeysBefore: 31,
  },
  {
    type: 'black',
    note: 'C#7',
    basic_note: 'c_sharp',
    id: 77,
    french_note: 'Do#',
    numBlackKeysBefore: 31,
  },
  {
    type: 'white',
    note: 'D7',
    basic_note: 'd',
    id: 78,
    french_note: 'Ré',
    numBlackKeysBefore: 32,
  },
  {
    type: 'black',
    note: 'D#7',
    basic_note: 'd',
    id: 79,
    french_note: 'Ré#',
    numBlackKeysBefore: 32,
  },
  {
    type: 'white',
    note: 'E7',
    basic_note: 'e',
    id: 80,
    french_note: 'Mi',
    numBlackKeysBefore: 33,
  },
  {
    type: 'white',
    note: 'F7',
    basic_note: 'f',
    id: 81,
    french_note: 'Fa',
    numBlackKeysBefore: 33,
  },
  {
    type: 'black',
    note: 'F#7',
    basic_note: 'f_sharp',
    id: 82,
    french_note: 'Fa#',
    numBlackKeysBefore: 33,
  },
  {
    type: 'white',
    note: 'G7',
    basic_note: 'g',
    id: 83,
    french_note: 'Sol',
    numBlackKeysBefore: 34,
  },
  {
    type: 'black',
    note: 'G#7',
    basic_note: 'g_sharp',
    id: 84,
    french_note: 'Sol#',
    numBlackKeysBefore: 34,
  },
  {
    type: 'white',
    note: 'A7',
    basic_note: 'a',
    id: 85,
    french_note: 'La',
    numBlackKeysBefore: 35,
  },
  {
    type: 'black',
    note: 'A#7',
    basic_note: 'a_sharp',
    id: 86,
    french_note: 'La#',
    numBlackKeysBefore: 35,
  },
  {
    type: 'white',
    note: 'B7',
    basic_note: 'b',
    id: 87,
    french_note: 'Si',
    numBlackKeysBefore: 36,
  },
  {
    type: 'white',
    note: 'C8',
    basic_note: 'c',
    id: 88,
    zone: '+2',
    french_note: 'Do',
    numBlackKeysBefore: 36,
  },
];

const KEYS_TO_NOTES = KEYBOARD_DATA.reduce((acc, note) => {
  acc[note.id] = note.note
  return acc
}, [] as string[]);
const KEYS_TO_NOTES_DETAILS = KEYBOARD_DATA.reduce((acc, note) => ({[note.id]: note, ...acc}), {});
const OCTAVES_FIRST_KEY = [4, 16, 28, 40, 52, 64];

const getClosestOctaveFirstKey = (key: number) => {
  return OCTAVES_FIRST_KEY.reduce((a, b) => {
    return Math.abs(b - key) < Math.abs(a - key) ? b : a;
  });
}

export {
  KEYBOARD_DATA,
  KEYS_TO_NOTES,
  KEYS_TO_NOTES_DETAILS,
  OCTAVES_FIRST_KEY,
  getClosestOctaveFirstKey
}